import React from "react";
import ResourceCard from "./ResourceCard";
import { DAYS } from "./mockProjectData";

const INITIALS_WIDTH = 52;
const COL_WIDTH = 220;

function fmtDate(weekStart, dayIndex) {
    if (!weekStart) return "";
    const d = new Date(weekStart);
    d.setDate(d.getDate() + dayIndex);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

const ProjectSchedulerGrid = ({ resources, weekStart }) => {
    return (
        <div style={{ display: "flex", alignItems: "stretch", gap: 0 }}>
            {/* Grid */}
            <div
                style={{
                    flex: 1,
                    overflowX: "auto",
                    borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        minWidth: INITIALS_WIDTH + COL_WIDTH * DAYS.length,
                        width: "100%",
                        tableLayout: "fixed",
                    }}
                >
                    <colgroup>
                        <col style={{ width: INITIALS_WIDTH }} />
                        {DAYS.map((d) => (
                            <col key={d} style={{ width: COL_WIDTH }} />
                        ))}
                    </colgroup>

                    {/* ── Header ── */}
                    <thead>
                        <tr>
                            <th
                                style={{
                                    background: "#f8fafc",
                                    borderBottom: "1px solid #e2e8f0",
                                    borderRight: "1px solid #e2e8f0",
                                    padding: "10px 8px",
                                    position: "sticky",
                                    left: 0,
                                    zIndex: 3,
                                    width: INITIALS_WIDTH,
                                }}
                            />
                            {DAYS.map((day, i) => (
                                <th
                                    key={day}
                                    style={{
                                        background: "#f8fafc",
                                        borderBottom: "1px solid #e2e8f0",
                                        borderRight: "1px solid #e2e8f0",
                                        padding: "10px 16px",
                                        textAlign: "left",
                                    }}
                                >
                                    <div style={{ fontSize: 13, fontWeight: 700, color: "#334155" }}>{day}</div>
                                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                                        {fmtDate(weekStart, i)}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* ── Rows ── */}
                    <tbody>
                        {resources.map((resource) => {
                            // Build cells with colspan support
                            const cells = [];
                            let skipCount = 0;

                            DAYS.forEach((day) => {
                                if (skipCount > 0) {
                                    skipCount--;
                                    return;
                                }
                                if (day === resource.startDay) {
                                    const span = resource.daySpan || 1;
                                    if (span > 1) skipCount = span - 1;
                                    cells.push({ day, task: resource, span });
                                } else {
                                    cells.push({ day, task: null, span: 1 });
                                }
                            });

                            return (
                                <tr key={resource.id}>
                                    {/* Initials cell */}
                                    <td
                                        style={{
                                            background: "#f8fafc",
                                            borderBottom: "1px solid #e2e8f0",
                                            borderRight: "1px solid #e2e8f0",
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            padding: "12px 4px",
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 2,
                                            width: INITIALS_WIDTH,
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: 11,
                                                fontWeight: 700,
                                                color: "#64748b",
                                                letterSpacing: "0.04em",
                                            }}
                                        >
                                            {resource.initials}
                                        </span>
                                    </td>

                                    {/* Day cells */}
                                    {cells.map(({ day, task, span }) => (
                                        <td
                                            key={day}
                                            colSpan={span}
                                            style={{
                                                borderBottom: "1px solid #e2e8f0",
                                                borderRight: "1px solid #e2e8f0",
                                                padding: task ? 8 : 0,
                                                verticalAlign: "top",
                                            }}
                                        >
                                            {task ? (
                                                <ResourceCard resource={task} />
                                            ) : (
                                                <div style={{ height: 110, background: "#fff" }} />
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProjectSchedulerGrid;
